/** @format */
import {HotspotKey} from '../../../../types';
import {Badge, BadgeBox, DescriptionBox, DescriptionText, HelpBox} from './styles';

interface Props {
  hotspotKey: HotspotKey;
}

const RenderHelpTooltip = ({hotspotKey}: Props) => {
  switch (hotspotKey) {
    case 'mediaplan':
      return (
        <HelpBox>
          <DescriptionBox>
            <DescriptionText>
              Узнайте, куда уходят деньги{'\n'}и что реально приносит результат. Настройте бюджет
              {'\n'}и KPI чтобы увидеть:
            </DescriptionText>
          </DescriptionBox>
          <BadgeBox>
            <Badge>Связь трат и результатов</Badge>
            <Badge>План-факт и прогнозы</Badge>
            <Badge>Аномалии и рекомендации</Badge>
          </BadgeBox>
        </HelpBox>
      );
    case 'sensors':
      return (
        <HelpBox>
          <DescriptionBox>
            <DescriptionText>
              Наша уникальная система мониторинга качества кампаний проверяет сотни параметров
              ежедневно.
            </DescriptionText>
            <DescriptionText>Настройте приоритеты под себя:</DescriptionText>
          </DescriptionBox>
          <BadgeBox>
            <Badge>
              Сигналы только
              <br />
              по важным проблемам
            </Badge>
            <Badge>
              Быстрая реакция
              <br />
              на аномалии
            </Badge>
            <Badge>
              Кампании под контролем
              <br />
              без стресса
            </Badge>
          </BadgeBox>
        </HelpBox>
      );
    case 'funnel':
      return (
        <HelpBox>
          <DescriptionBox>
            <DescriptionText>
              Определите в чем проблема, на сайте или в рекламе. Сравнивайте воронку с KPI и
              действиями в кабинете.
            </DescriptionText>
          </DescriptionBox>
          <BadgeBox>
            <Badge>Всплески и провалы</Badge>
            <Badge>Просадки конверсии</Badge>
            <Badge>
              Этапы воронки
              <br />
              на общем таймлайне
            </Badge>
          </BadgeBox>
        </HelpBox>
      );
    case 'feeds':
      return (
        <HelpBox>
          <DescriptionBox>
            <DescriptionText>
              Следите за ассортиментом и не теряйте продажи. Сенсоры проверяют всё важное:
            </DescriptionText>
          </DescriptionBox>
          <BadgeBox>
            <Badge>Наличие ключевых товаров</Badge>
            <Badge>Актуальность данных</Badge>
            <Badge>Ошибки и аномалии в фидах</Badge>
          </BadgeBox>
        </HelpBox>
      );
    default:
      return null;
  }
};

export {RenderHelpTooltip};
